import React, { useEffect } from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import { loadCommissions } from "../../../redux/features/commissions/actions";
import { useAppSelector } from "../../../redux/hooks";
import { CommissionsTable } from "./CommissionsTable";

/**
 * Displays commissions that are outstanding (unpaid and not yet payable) for one or
 * more sales reps.
 *
 * On mount (and whenever `salesRepIds` or `commissionSource` changes) it fetches
 * the unpaid commission records from the API via {@link loadCommissions} and renders
 * them inside {@link CommissionsTable}.
 *
 * @param salesRepIds - Array of sales rep IDs whose unpaid commissions should be displayed.
 *   Passed down from {@link CommissionsTabView}; an empty array causes no fetch to fire.
 */
export const CommissionsUnpaid = ({salesRepIds}:{salesRepIds:number[]}) => {
  const commissionsList = useAppSelector(state => state.commissions.commissionsList);
  const commissionSource = useAppSelector(state => state.commissions.commissionSource);

  const legacyInvoiceStates =  [
    'Draft',
    'Sent',
    'Viewed',
    'Partial',
    'Disputed',
    'Paid',
    'Pending',
    'Outstanding',
    'Declined',
  ];
  const hydraInvoiceStates =  ['sent', 'partial', 'disputed', 'resolved', 'overdue', 'viewed', 'paid'];
  const invoiceStates = JSON.stringify({
    legacyInvoiceStates,
    hydraInvoiceStates,
  });

  // const invoiceStates = (
  //   commissionSource === 'legacy'
  //     ? ['Draft','Sent', 'Viewed', 'Partial', 'Disputed', 'Paid', 'Pending', 'Outstanding', 'Declined']
  //     : ['sent','partial','disputed', 'resolved', 'overdue', 'viewed', 'paid']
  // )

  useEffect(()=>{
    loadCommissions(salesRepIds, `/unpaid?invoiceStates=${invoiceStates}&source=${commissionSource}`);
  }, [salesRepIds, commissionSource]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Row>
        <Col>
          <br></br>
          {/* <p>Shown Invoice States</p>
            {invoiceStates.map((invoiceState) => <Badge pill variant="primary">{invoiceState}</Badge>)} */}
        </Col>
      </Row>
      <CommissionsTable commissionsList={commissionsList} />
    </>
  );
};